import React from 'react';
import BasePage, { IBasePageProps } from '@/pages/BasePage';
import SignUp from '@/components/SignUp';
import paths from '@/routes/paths';
import Icon, { IconType } from '@/components/Icon';
import { getAppTheme, setScreenColor, getIntl } from '@/components/App/App';
import Layout from '@/components/Layout/Layout';
import { prefix } from '.';
import { getPlatformPayInfo, parseRouteParams } from '@/utils';

export interface ISignUpPageProps extends IBasePageProps { }

class SignUpPage extends BasePage<ISignUpPageProps> {
  componentDidMount() {
    const appTheme = getAppTheme();
    if (appTheme.primaryColor && appTheme.lightBackgroundColor) {
      setScreenColor(appTheme.primaryColor, appTheme.lightBackgroundColor);
    }

    super.componentDidMount();
  }

  signUpClick = () => {
    const routeParams = parseRouteParams(this.props);
    const { fromPage = '' } = routeParams;
    const payInfoObj = getPlatformPayInfo('');
    const { storeSlug, mode = '', tableUuid } = payInfoObj || {}

    if (fromPage === 'checkout' && storeSlug) {
      let search = '';

      if (mode === 'D') {
        search += 'mode=dedicated';

        if (tableUuid) {
          search += `${search ? '&' : ''}uuid=${tableUuid}`;
        }
      }
      this.handleGoBack({
        path: paths.MENU_LIST,
        pathParams: {
          storeSlug,
        },
        search
      })
    } else {
      this.handleGoHome(true);
    }
  };

  render() {
    return (
      <Layout
        {...this.props} 
        navIcon={<Icon className="html-embed-7 w-embed" type={IconType.LEFT_OUTLINED} />}
        onLeftClick={() =>
          this.handleGoBack({
            path: paths.HOME,
            runGoBack: true,
          })
        }
        navContent={getIntl().page.signup}
        isFooter={false}
        className={prefix}
      >
        <SignUp signUpClick={this.signUpClick} />
      </Layout>
    );
  }
}

export default SignUpPage;
